<section #section>
  <pre>{{ curl }}</pre>
  <div tooltipPosition="left" title="Copy to clipboard" class="no-print"><i (click)="copyToClipboard()" class="mdi mdi-content-copy"></i></div>
</section>
